<template>
  <div :class="{'has-logo':showLogo}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBackground"
        :unique-opened="false"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="item in menus" :key="item.id" :item="item" :base-path="item.id" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/config/styles/variables.scss'

export default {
  name: 'BaseLayoutSidebar',
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'menus',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { path, meta} = route
      // if set path, the sidebar will highlight the path you set
      // if (meta.activeMenu) {
      //   return meta.activeMenu
      // }
      let menuItem = {}
      if (meta && meta.authUrl !== '' && meta.authUrl !== undefined) {
        menuItem = this.$store.state.permission.menuUrlMap.get(meta.authUrl)
      } else {
        menuItem = this.$store.state.permission.menuUrlMap.get(path)
      }
      if (menuItem) {
        return menuItem.id
      } else {
        return ''
      }
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  methods: {
    getMenuIdByPath(menu, path) {
      this.$store.permission.menuUrlMap.get(path)
      if (menu && this.menuId && menu.length > 0) {
        let i
        for (i = 0; i < menu.length; i++) {
          if (menu[i].url === path) {
            this.menuId = menu[i].id
            break
          } else {
            this.getMenuIdByPath(menu[i].children, path)
          }
        }
      }
    }
  }
}
</script>
